// AnimalCareFAQSection.tsx

import { useEffect, useState } from 'react';
import axios from 'axios';
import { newServer } from '../../../src/constants/constants';
import { useTranslation } from 'react-i18next';
const FONT_STYLE = { fontFamily: 'Poppins, sans-serif' };

const AnimalCareFAQSection = () => {
  const { t, i18n } = useTranslation();
  const [expandedCareType, setExpandedCareType] = useState<string | null>(null);
  const [careTypes, setCareTypes] = useState<any[]>([]);
  const locale = i18n.language;
  useEffect(() => {
    const fetchCareTypes = async () => {
      try {
        const currentLanguage = i18n.language || 'en';
        const endpoint = `${newServer}lawyer-types/get-all-lawyer-types?lang=${currentLanguage}`;
        const response = await axios.get(endpoint);
        setCareTypes(response.data as any[]);
      } catch (error) {
        console.error('Error fetching care types:', error);
      }
    };

    fetchCareTypes();
  }, [i18n.language]); // Re-ejecutar cuando cambie el idioma

  const toggleExpand = (searchParam: string) => {
    setExpandedCareType((prev) => (prev === searchParam ? null : searchParam));
  };

  return (
    <div className='max-w-4xl mx-auto px-4 py-8'>
      <h2 className='text-4xl font-bold text-center text-black' style={FONT_STYLE}>
      {t('not_sure_what').toString()}{' '}
      </h2>
      <p className='mt-2 text-center text-slate-700 font-semibold' style={FONT_STYLE}>
        {t('click_a_category').toString()}
      </p>
      {careTypes.map((careType) => (
        <div key={careType.id} className='p-4 border rounded-lg shadow-sm bg-white my-3'>
          {/* Care Type Header */}
          <div className='flex justify-between items-center'>
            <h3 className='text-xl font-semibold'>
              <a
                href={`/directory/search?type=lawyer&search=${
                  careType.skill ? careType.skill : careType.title
                }`}
                rel='noopener noreferrer'
                className='text-gray-700 hover:underline capitalize'
              >
                {careType.title}
              </a>
            </h3>
            <button
              onClick={() => toggleExpand(careType.id)}
              className='text-lg font-bold text-black hover:text-pink-600 p-3 rounded-xl'
            >
              {expandedCareType === careType.id ? '-' : '+'}
            </button>
          </div>
          {/* Expandable Section */}
          {expandedCareType === careType.id && (
            <div className='mt-2 text-slate-700'>
              <p>
                <strong>{t('handles_label').toString()}</strong> {careType.handles}
              </p>
              <p>
                <strong>{t('example_label').toString()}</strong> {careType.example}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default AnimalCareFAQSection;
